import { useQuery } from '@tanstack/react-query'
import { api } from '@api'
import { secureTokenStore } from '@store'

export const ACCOUNT_SECURITY_QUERY_KEY = 'account-security'

/** How the logged-in person can sign in: a password, a linked provider, or both. */
export interface AccountSecurity {
  hasPassword: boolean
  linkedProviders: string[]
}

export const fetchAccountSecurity = async (): Promise<AccountSecurity> =>
  (await api.get<AccountSecurity>('/me/account-security')).data

export const useAccountSecurity = (enabled = true) =>
  useQuery<AccountSecurity>({
    queryKey: [ACCOUNT_SECURITY_QUERY_KEY],
    queryFn: fetchAccountSecurity,
    enabled: enabled && !!secureTokenStore.getAccessToken(),
  })
